<div
    #bigWGridContainer
    class="simple-data-grid"
    [ngClass]="{'header-series': (isMultiSeries || isStacked || isStackedArea), 'mirrored-bar-chart': isMirrored}"
    appMousedownOutside
    (mousedownOutside)="deselectAllSelected()"
>

    @if (showGrid) {
        <app-data-grid
            #dataGridComponent
            [gridConfiguration]="gridConfiguration"
            (gridReadyEvent)="onGridReady()"
            (rowClickedEvent)="onRowClicked($event)"
            (virtualColumnsChanged)="onVirtualColumnsChanged()"
        >
        </app-data-grid>
    }
</div>
